import { AxiosResponse } from "axios";
import { ApiGenericResponse } from "../ApiGenericResponse";
import { Command, HttpVerbType, API_PREFIX, API_VERSION } from "../Command";

const ENDPOINT = "/fitness_statistics/any_with_branchid";

export class AnyStatisticsWithBranchIdCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "get";

    params: AnyStatisticsWithBranchIdReqData = null;

    constructor(branchId: number) {
        super();
        this.params = new AnyStatisticsWithBranchIdReqData(branchId);
    }

    public async execute(): Promise<AnyStatisticsWithBranchIdResData> {
        var res = await this.executeCommand(null, null, this.params);
        return new AnyStatisticsWithBranchIdResData(res);
    }
}

export class AnyStatisticsWithBranchIdReqData {
    id: number;
    constructor(branchId: number) {
        this.id = branchId;
    }
}

export class AnyStatisticsWithBranchIdResData extends ApiGenericResponse {
    result: boolean;

    constructor(response: AxiosResponse) {
        super(response);
        this.result = false;
        if (response.data && response.data.Payload && response.data.Payload.Result) this.result = response.data.Payload.Result;
    }
}
